"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketAnalyticsConfigurationInput_1 = require("./GetBucketAnalyticsConfigurationInput");
var GetBucketAnalyticsConfigurationOutput_1 = require("./GetBucketAnalyticsConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketAnalyticsConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketAnalyticsConfiguration",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?analytics"
    },
    input: {
        shape: GetBucketAnalyticsConfigurationInput_1.GetBucketAnalyticsConfigurationInput
    },
    output: {
        shape: GetBucketAnalyticsConfigurationOutput_1.GetBucketAnalyticsConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketAnalyticsConfiguration.js.map